<p *ngIf="question_title">{{ question_title }}</p>

<div class="grid">
  <div class="col-12">
    <label class="grey-text">Indirizzo di destinazione attuale</label>
    <p class="mt-1 mb-0">{{ currentAddressLabel || 'Nessun indirizzo disponibile sul ticket.' }}</p>
  </div>

  <div
    class="col-12"
    *ngIf="selectedRegistry">
    <label class="grey-text">Nuovo indirizzo selezionato</label>
    <div class="flex align-items-center justify-content-between mt-1">
      <p class="mb-0">
        {{ selectedRegistry.name }} — {{ selectedRegistry.address }},
        {{ selectedRegistry.zip_code }} {{ selectedRegistry.city }} ({{
          selectedRegistry.province
        }})
      </p>
      <p-button
        icon="pi pi-trash"
        pTooltip="Torna all'indirizzo del ticket"
        tooltipPosition="bottom"
        styleClass="butt red ml-2"
        [rounded]="true"
        (click)="resetToDefault()"></p-button>
    </div>
  </div>

  <div class="col-12 flex flex-wrap gap-2">
    <p-button
      type="button"
      label="Scegli un'altra azienda"
      icon="pi pi-search"
      styleClass="butt"
      [rounded]="true"
      pTooltip="Imposta l'indirizzo di destinazione della consegna all'azienda selezionata"
      tooltipPosition="top"
      (click)="openRegistryPicker()"></p-button>
    <p-button
      *ngIf="allowTransfer"
      type="button"
      label="Trasferisci in un altro magazzino"
      icon="pi pi-arrow-right-arrow-left"
      styleClass="butt"
      [rounded]="true"
      pTooltip="Genera un movimento di trasferimento"
      tooltipPosition="top"
      (click)="transfer()"></p-button>
  </div>
</div>

<div class="modal-footer">
  <div class="flex justify-content-between">
    <p-button
      icon="pi pi-times"
      (click)="close()"
      styleClass="butt red"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (click)="confirm()"
      styleClass="butt"
      [rounded]="true"></p-button>
  </div>
</div>
